exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n[data-toggle=collapse] .fa:before {\n  content: \"\\F139\";\n}\n[data-toggle=collapse].collapsed .fa:before {\n  content: \"\\F13A\";\n}\n.filter-header {\n  padding: 0;\n}\n.filter-content {\n  margin-top: 10px;\n  /*border-top: 1px solid #dee2e6 !important;*/\n}", ""]);

// exports
